<template>
    <div class="down-detail-wrapper">
        <Table
            :curPage="curPage"
            :config="tableConfig"
            :dataset="tableData"
            :total="standTotal"
            @columnClick="tableColumnClick"
            @pageChange="pageChange"
        />
    </div>
</template>
<script>
import Table from "@/views/zhiji/bComponents/table/Table";
import { exportLogTable } from "./robotExportLogConfig.js"
export default {
    name:"ToDownLoadTab",
    props: ["getExportList"],
    components: {
        Table
    },
    data() {
        return {
            curPage: 1,
            tableConfig: exportLogTable(),
            tableData: [],
            standTotal: "",
            curPageLen: exportLogTable().pageLength,
        }
    },
    mounted () {
        this.getRobotExportData();
    },
    methods: {
        tableColumnClick(data) {
            if (data.colId == "operate") {
                const url = data.rowData.columns.filter(item => item.colId == "operate")[0].data.url;
                window.open(url);
            }
        },
        pageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPage == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPage = data.curPage;

            this.getRobotExportData()
        },
        async getRobotExportData() {
            const { count, list } = await this.getExportList({
                page: this.curPage,
                size: this.curPageLen
            });
            this.standTotal = count;
            this.tableData = list
        },
    },
}
</script>
<style scoped lang="less">
.down-detail-wrapper {
    margin-top: 10px;
}
</style>
